import { FC } from 'react'
import { useTheme } from '@emotion/react'

// icons
import { icons } from '@/assets'
// hooks
import { useAppDispatch } from '@/hooks'
// features
import { trackCloseTrackBlockModal } from '@/features'
// components
import { CardHeaderMobile, ModalCardTitle, ModalCardSubtitle, Error } from '@/components'

// components
import { TrackBlockForm } from './components'
// styles
import { styles } from './styles'

type TrackBlockCardProps = {}

export const TrackBlockCard: FC<TrackBlockCardProps> = () => {
  const theme = useTheme()

  const dispatch = useAppDispatch()
  const trackBlockError = ''

  return (
    <div
      css={styles(theme).card.main}
      onClick={(e) => e.stopPropagation()}
      aria-hidden="true"
    >
      {/* mobile header */}
      <div css={styles(theme).card.header}>
        <CardHeaderMobile onCloseClick={() => dispatch(trackCloseTrackBlockModal())} />
      </div>

      {/* title */}
      <div css={styles(theme).card.title}>
        <ModalCardTitle text="Block Track" icon={icons.AlertTriangle} />
      </div>

      {/* subtitle */}
      <div css={styles(theme).card.subtitle}>
        <ModalCardSubtitle text="Are you sure you want to block this track?" />
      </div>

      <div css={styles(theme).card.content.main}>
        {/* form */}
        <div css={styles(theme).card.content.form}>
          <TrackBlockForm />
        </div>

        <div css={styles(theme).card.content.error}>
          <Error error={trackBlockError} />
        </div>
      </div>
    </div>
  )
}

TrackBlockCard.propTypes = {}
